import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { signedInRoute } from '@/router/root'

export const profileRoute = createRoute({
  getParentRoute: () => signedInRoute,
  path: '/profile',
  component: lazyRouteComponent(() => import('./pages'), 'ProfilePage'),
})

export const profileRoutes = [profileRoute]
